const productDetailMasterColumns = () => {
  return (
    [
      {
        Header: 'Display Sequence',
        accessor: 'displayseq',
        editType: 'Number',
        options: []
      },
      {
        Header: 'Product Id',
        accessor: 'productid',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Profile',
        accessor: 'productcode',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Product',
        accessor: 'producttype',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Dimension',
        accessor: 'productdescription',
        editType: 'inputField',
        options: []
      },

      {
        Header: 'Active ?',
        accessor: 'isactive',
        editType: 'Boolean',
        options: []
      },
      {
        Header: 'Remarks',
        accessor: 'remarks',
        editType: 'inputField',
        options: []
      }

    ]
  )
}

export default productDetailMasterColumns;
